import React from "react";
import Icon from "../../../components/AppIcon";

const ORANGE = "#F27E33";

const Card = ({ icon, title, children }) => (
  <div
    className="rounded-2xl p-5 mb-5"
    style={{
      background: "rgba(255,255,255,.06)",
      border: "1px solid rgba(255,255,255,.15)",
      backdropFilter: "blur(6px)",
      boxShadow: `inset 0 0 50px ${ORANGE}22`,
    }}
  >
    <div className="flex items-center gap-2 mb-3">
      <div
        className="w-9 h-9 rounded-lg flex items-center justify-center"
        style={{ background: "rgba(255,255,255,.10)" }}
      >
        <Icon name={icon} size={18} className="text-white" />
      </div>
      <h3 className="font-orbitron text-white text-base">{title}</h3>
    </div>
    <div className="font-body text-white/85 text-sm leading-relaxed">
      {children}
    </div>
  </div>
);

export default function ContactInfo() {
  return (
    <div>
      <Card icon="Phone" title="Líneas de Atención">
        <p>Comercial: <span className="text-white">(+57) 3112202274</span></p>
        <p>Soporte: <span className="text-white">(+57) 3225107655</span></p>
        <p className="text-white/70 text-xs mt-1">Lunes a Viernes, 8:00–18:00</p>
      </Card>

      <Card icon="Mail" title="Correo">
        <p className="break-all">Sirecc.sas@gmail.com</p>
      </Card>

      <Card icon="MapPin" title="Ubicación">
        <p>Bogotá D.C., Colombia</p>
      </Card>

      <Card icon="Shield" title="Por qué SIRECC">
        <ul className="list-disc pl-5 space-y-1">
          <li>Plan de trabajo claro y trazable</li>
          <li>Normativa colombiana vigente (RETIE, NSR-10, NTC)</li>
          <li>Garantía y soporte post-entrega</li>
        </ul>
      </Card>
    </div>
  );
}
